/**
 * @generated SignedSource<<33a65847197b891e3b9f2ed58c1c9c13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FlyPreviewStatus = "RUNNING" | "STOPPED" | "STARTING" | "DEGRADED" | "%future added value";
export type StartFlyPreviewInput = {
  slug: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StartFlyPreviewMutation$variables = {
  input: StartFlyPreviewInput;
};
export type StartFlyPreviewMutation$data = {
  readonly startFlyPreview: {
    readonly flyPreview: {
      readonly id: string;
      readonly slug: string;
      readonly branchName: string | null;
      readonly webUrl: string;
      readonly status: FlyPreviewStatus;
      readonly machinesTotal: number;
      readonly machinesRunning: number;
      readonly lastUsedAt: string | null;
      readonly lastUsedKnown: boolean;
      readonly createdAt: string | null;
      readonly deployedAt: string | null;
    } | null;
  } | null;
};
export type StartFlyPreviewMutation = {
  variables: StartFlyPreviewMutation$variables;
  response: StartFlyPreviewMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartFlyPreviewPayload",
    "kind": "LinkedField",
    "name": "startFlyPreview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FlyPreview",
        "kind": "LinkedField",
        "name": "flyPreview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "branchName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machinesTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machinesRunning",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUsedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUsedKnown",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deployedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartFlyPreviewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StartFlyPreviewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c8fde483017743a37fa85c42aeb5ae28",
    "id": null,
    "metadata": {},
    "name": "StartFlyPreviewMutation",
    "operationKind": "mutation",
    "text": "mutation StartFlyPreviewMutation(\n  $input: StartFlyPreviewInput!\n) {\n  startFlyPreview(input: $input) {\n    flyPreview {\n      id\n      slug\n      branchName\n      webUrl\n      status\n      machinesTotal\n      machinesRunning\n      lastUsedAt\n      lastUsedKnown\n      createdAt\n      deployedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7246741e7a5709d946f529fd6e5e399a";

export default node;
